module.exports = __webpack_public_path__ + "static/media/gallery-wide-3.ed0e272e.jpg";